import { combineReducers } from 'redux'
import kids from './kids'

export default combineReducers({
  kids
})